import { Home, Luggage, Compass, BarChart3, CircleUser } from "lucide-react";

// Level-1 destinations — shared by Sidebar (desktop) and MobileTabs (bottom bar)
export const DESTINATIONS = [
  { key: "home", label: "Home", path: "/home", root: "/home", icon: Home },
  { key: "trips", label: "Trips", path: "/trips", root: "/trips", icon: Luggage },
  { key: "plan", label: "Plan", path: "/plan/ai", root: "/plan", icon: Compass },
  { key: "insights", label: "Insights", path: "/insights/budget", root: "/insights", icon: BarChart3 },
  { key: "you", label: "You", path: "/you/profile", root: "/you", icon: CircleUser },
];

// Level-2 sections per destination — drives SectionTabs (and mobile segmented controls later)
export const PLAN_SECTIONS = [
  { key: "ai", label: "Ask AI", path: "/plan/ai" },
  { key: "search", label: "Search", path: "/plan/search" },
  { key: "scenarios", label: "Scenarios", path: "/plan/scenarios" },
  { key: "wishlist", label: "Wishlist", path: "/plan/wishlist" },
];

export const INSIGHTS_SECTIONS = [
  { key: "budget", label: "Budget", path: "/insights/budget" },
  { key: "presence", label: "Presence", path: "/insights/presence" },
];

export const YOU_SECTIONS = [
  { key: "profile", label: "Profile", path: "/you/profile" },
  { key: "people", label: "People", path: "/you/people" },
  { key: "family", label: "Family", path: "/you/family" },
  { key: "calendars", label: "Calendars", path: "/you/calendars" },
  { key: "notifications", label: "Notifications", path: "/you/notifications" },
];
